import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Info from '@material-ui/icons/InfoOutlined'
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace'
import Button from '@material-ui/core/Button'
import { DropzoneArea } from 'material-ui-dropzone'
import { ProductParameterValue } from '../../../../product/model'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme: any) => ({
    root: {
        '& .ProductParameterExpansionDesignOwn-dropzone': {
            margin: theme.spacing(1, 0),

            '& .MuiGrid-root.MuiGrid-item .MuiSvgIcon-root': {
                color: '#909090',
                padding: '16px'
            },
            '& .MuiGrid-root.MuiGrid-item .MuiFab-label .MuiSvgIcon-root': {
                color: '#909090',
                padding: '0'
            }
        }
    }})
)

export interface ProductParameterExpansionDesignOwnProps {
    back: () => void
    description?: boolean
    value: ProductParameterValue
    manual: string
    valueSelect: (value: ProductParameterValue) => void
    valueSelected: ProductParameterValue[]
    twoSided: boolean
}

export const ProductParameterExpansionDesignOwn = (props: ProductParameterExpansionDesignOwnProps) => {
    const classes = useStyles(props)
    const [filesSelected, setFilesSelected] = React.useState([] as File[])
    const [description, setDescription] = React.useState('')
    // const initialFiles =
    //     props.valueSelected && props.valueSelected.length && props.valueSelected[0].filesUploaded
    //         ? props.valueSelected[0].filesUploaded.map(it => it.url)
    //         : []
    const save = () => {
        const newValue = { ...props.value }
        newValue.filesSelected = filesSelected
        newValue.description = description
        props.valueSelect(newValue)
    }
    return <Grid container direction='column' className={classes.root}>
        <Grid item container justify='space-between' wrap='nowrap'>
            <Grid item style={{ cursor: 'pointer' }}>
                <Grid container alignItems='center' className='ProductParameterExpansionDesignOwn-recommendedParameters'>
                    <Info />
                    <a href={props.manual} target='_blank' >Recommended parameters</a>
                </Grid>
            </Grid>
            <Grid item onClick={() => props.back()} style={{ cursor: 'pointer' }}>
                <Grid container alignItems='center'>
                    <KeyboardBackspace />
                    <div>Go back</div>
                </Grid>
            </Grid>
        </Grid>
        <Grid item>
            <DropzoneArea
                dropzoneClass='ProductParameterExpansionDesignOwn-dropzone'
                onChange={setFilesSelected.bind(this)}
                filesLimit={12} />
        </Grid>
        {props.description && <Grid item>
            <textarea
                placeholder='Description'
                rows={4}
                value={description}
                onChange={e => setDescription(e.target.value)}
                style={{width: '100%'}}
                ></textarea>
            {/* <TextField
                label='Description'
                multiline
                rows='4'
                value={description}
                variant='outlined'
                style={{width: '100%'}}
                onChange={e => setDescription(e.target.value)}
            /> */}
        </Grid>}
        <Grid item container justify='flex-end'>
            <Button color='primary' onClick={save} disabled={!filesSelected || !filesSelected.length}>Save</Button>
        </Grid>
    </Grid>
}